import {
  FormDropdown,
  FormInput,
  FormSubmit,
  PageView,
  Text,
} from "components/YeyComponents";
import {
  Grid,
  Card,
  CardContent,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { techSheetTypeLOV, techSheetContextLOV  } from "utils/Utils";

import DOMPurify from "dompurify";
import Handlebars from "handlebars";
import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-html";
import "ace-builds/src-noconflict/theme-tomorrow";
import "ace-builds/src-noconflict/ext-language_tools";
import "ace-builds/src-noconflict/worker-html";
import {
  createTechSheet,
  updateTechSheet,
  getTechSheet,
  clearAll,
} from "redux/actions/techSheet";

Handlebars.registerHelper("upper", function (str) {
  return str.toUpperCase();
});
Handlebars.registerHelper("lower", function (str) {
  return str.toLowerCase();
});
Handlebars.registerHelper("cap", function (str) {
  return str.charAt(0).toUpperCase() + str.toLowerCase().slice(1);
});

Handlebars.registerHelper("for", function (context, first, range, options) {
  if (!Array.isArray(context) || context.length === 0) return;
  var ret = "";
  for (let i = first; i < Math.max(context.length, first + range); i++) {
    const value = context[i];
    if (value === undefined || value === null) continue;
    ret = ret + options.fn(value);
  }
  return ret;
});

Handlebars.registerHelper("split", function (context, range, options) {
  if (!Array.isArray(context) || context.length === 0) return;
  var ret = "";
  for (let i = 0; i < context.length; i += range) {
    const chunk = context.slice(i, i + range);
    if (chunk.length === 0) continue;
    ret += options.fn(chunk);
  }
  return ret;
})

const DEFAULT_TEMPLATE = `<style>
  /* Estilize o documento aqui */
  h1 { text-align: center } body { font-family: 'Times New Roman', Times,
  serif;line-height: 1.2; letter-spacing: 0.3px; word-spacing: 1px; }
  .content-uppercase span { text-transform: uppercase; } b { font-weight: bold
  !important; } td, th { padding: 5px;font-size:12pt; }
</style>

<div class="page">
  <!-- Estruture o documento aqui -->
  <div style="width: 85%; margin: 10mm 7.5%;">
    <div style="text-align: justify;">
      <h1>Página 1</h1> 
      <p>Conteúdo da Página</p>
    </div>
  </div>
</div>
`;

const TEMPLATE_VARIABLES = {};

techSheetTypeLOV.forEach((item) => {
  TEMPLATE_VARIABLES[item.id] = (() => {
    let context = {};
    item.variables?.forEach((variable) => {
      context[variable] = techSheetContextLOV[variable]?.placeholder;
    });
    return context;
  })();
});

const FichaTecnicaForm = () => {
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
    setValue,
  } = useForm();
  const techSheetData = useSelector((state) => state.techSheet);
  const [htmlStructure, setHtmlStructure] = useState(null);
  const [techSheetType, setTechSheetType] = useState(null);

  const dispatch = useDispatch();
  const params = useParams();
  const history = useHistory();

  useEffect(() => {
    if (params?.techSheetId) {
      dispatch(getTechSheet(params.techSheetId));
    } else {
      dispatch(clearAll());
    }
  }, [dispatch, params]);

  useEffect(() => {
    if (techSheetData?.id) {
      Object.entries(techSheetData || {}).forEach(([key, value]) => {
        if (key === "htmlStructure") {
          setHtmlStructure(techSheetData?.htmlStructure);
        } else {
          setValue(key, value);
          if (key === "type") {
            setTechSheetType(value);
          }
        }
      });
    } else {
      reset(techSheetData);
      setHtmlStructure(DEFAULT_TEMPLATE);
    }
  }, [techSheetData, setValue]);

  const onSubmit = (data) => {
    delete data.updatedAt;
    delete data.updatedBy;
    const payload = {
      ...data,
      htmlStructure: htmlStructure,
    };
    dispatch(
      params?.techSheetId
        ? updateTechSheet(payload)
        : createTechSheet(payload, history.push)
    );
  };

  function onChangeAceEditor(newValue) {
    setHtmlStructure(newValue);
  }

  function onLoadAceEditor() {
    setHtmlStructure(DEFAULT_TEMPLATE);
  }

  const selectTechSheetType = useCallback(
    (data) => {
      setTechSheetType(data.value);
      setValue("type", data.value);
    },
    [setValue]
  );

  // Compilação do template usando useMemo para performance
  const renderedHtml = useMemo(() => {
    try {
      const template = Handlebars.compile(htmlStructure || "");
      const rawHtml = template(TEMPLATE_VARIABLES[techSheetType] || {});

      return DOMPurify.sanitize(rawHtml, {
        ALLOWED_TAGS: [
          "style",
          "h1",
          "h2",
          "h3",
          "p",
          "div",
          "span",
          "strong",
          "em",
          "ul",
          "ol",
          "li",
          "table",
          "thead",
          "tbody",
          "tr",
          "td",
          "br",
        ],
        ALLOWED_ATTR: [
          "style",
          "class",
          "id",
          "align",
          "valign",
          "width",
          "height",
          "colspan",
          "rowspan",
        ],
        USE_PROFILES: { html: true },
        FORCE_BODY: true,
      });
    } catch (error) {
      return `<p style="color:red;">Erro no template: ${error.message}</p>`;
    }
  }, [htmlStructure, techSheetType]);

  const renderHelperCards = useMemo(() => {
    let variables_draw = [];
    const variables_str_arr = techSheetTypeLOV.find(
      (item) => item.id == techSheetType
    )?.variables;
    if (typeof variables_str_arr === "object" && variables_str_arr.length > 0) {
      variables_str_arr.map((item) => {
        if (
          techSheetContextLOV[item] &&
          techSheetContextLOV[item]?.label &&
          techSheetContextLOV[item]?.placeholder
        ) {
          const get_placeholder = (() => {
            const placeholder = techSheetContextLOV[item]?.placeholder
            switch (typeof placeholder) {
              case "string":
              case "number":
                return placeholder;
              case "boolean":
                return placeholder ? "Sim" : "Não";
              case "object":
                return Object.keys(placeholder[0]).join(", ");
              default:
                return String(typeof placeholder).toUpperCase();
            }
          })

          variables_draw.push({
            id: item,
            label: techSheetContextLOV[item]?.label,
            placeholder: get_placeholder(),
          });
        }
      });
    }
    if (typeof variables_draw === "object" && variables_draw.length > 0) {
      return variables_draw.map((item) => {
        return (
          <Card
            style={{
              border: "1px rgb(204,204,204) solid",
            }}
          >
            <CardContent>
              <Text type="label" size="1.0em">
                <b>{item.label}</b>
              </Text>
              <Text type="label" color="rgb(64, 64, 64)" size="1.025em">
                {"{{" + item.id + "}}"}
              </Text>
              <Text type="label" color="rgb(104, 104, 104)" size="0.85em">
                Exemplo: "{item.placeholder}"
              </Text>
            </CardContent>
          </Card>
        );
      });
    }
    return (
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Text>Nenhuma variaveis disponivel.</Text>
      </div>
    );
  }, [techSheetType]);

  return (
    <PageView>
      <Text type="title" padding={{ top: "1em" }}>
        {params?.techSheetId ? "Editar" : "Adicionar"} Ficha Técnica
      </Text>
      <hr style={{ marginTop: "2em" }} />
      <form
        style={{ width: "100%", flex: 1 }}
        onSubmit={handleSubmit(onSubmit)}
      >
        <Grid
          container
          direction="row"
          justify="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid item xl={6} lg={6} md={6} sm={12} xs={12} direction="column">
            <FormInput
              name="name"
              label="Nome da Ficha Técnica"
              control={control}
              errors={errors}
              defaultValue={techSheetData?.name}
              required
            />
          </Grid>
          <Grid item xl={6} lg={6} md={6} sm={12} xs={12} direction="column">
            <FormDropdown
              placeholder="Selecionar um tipo..."
              name="type"
              label="Tipo de Ficha Técnica"
              values={
                new Array(
                  ...techSheetTypeLOV.map((item) => {
                    return {
                      label: item.label,
                      value: item.id,
                    };
                  })
                )
              }
              control={control}
              errors={errors}
              getChangeValue={(e) => selectTechSheetType(e)}
              width="70%"
              required
              disabled={techSheetData?.id ? true : false}
            />
          </Grid>
        </Grid>

        <hr style={{ marginTop: "2em", marginBottom: "2em" }} />

        <Accordion
          style={{
            border: "1px rgb(204, 204, 204) solid",
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
            style={{
              borderBottom: "1px rgb(204, 204, 204) solid",
            }}
          >
            <Text>Variaveis</Text>
          </AccordionSummary>
          <AccordionDetails
            style={{
              height: "auto",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "0.5em",
                width: "100%",
                height: "auto",
                maxHeight: "512px",
                flexWrap: "wrap",
                overflowY: "auto",
                justifyContent: "center",
              }}
            >
              {renderHelperCards}
            </div>
          </AccordionDetails>
        </Accordion>
        <hr style={{ marginTop: "2em", marginBottom: "2em" }} />

        <Grid
          container
          direction="row"
          justify="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid item xl={6} lg={6} md={6} sm={12} xs={12} direction="column">
            <Text padding={{ top: "0.25em" }}>Código Fonte</Text>
            <AceEditor
              style={{
                border: "1px #D3D3D3 solid",
              }}
              placeholder="Estrutura HTML da Ficha Técnica aqui..."
              name="ace_editor"
              mode="html"
              theme="tomorrow"
              onChange={onChangeAceEditor}
              onLoad={onLoadAceEditor}
              fontSize={14}
              width="100%"
              height="calc(1123px*0.85)"
              lineHeight={19}
              showPrintMargin={true}
              showGutter={true}
              highlightActiveLine={true}
              value={htmlStructure}
              setOptions={{
                enableBasicAutocompletion: false,
                enableLiveAutocompletion: false,
                enableSnippets: false,
                enableMobileMenu: true,
                showLineNumbers: true,
                tabSize: 2,
                useWorker: false,
              }}
              editorProps={{ $blockScrolling: true }}
            />
          </Grid>
          <Grid item xl={6} lg={6} md={6} sm={12} xs={12} direction="column">
            <Text padding={{ top: "0.25em" }}>Pré Visualização</Text>
            <iframe
              style={{
                width: "100%",
                height: "1123px",
                margin: 0,
                padding: 0,
                backgroundColor: "#f0f0f0",
                display: "block",
                zoom: 0.85,
                border: "1px #D3D3D3 solid",
              }}
              ref={(el) => {
                if (el) {
                  const doc = el.contentDocument || el.contentWindow?.document;
                  doc.open();
                  doc.write(`
                    <html>
                      <head>
                        <style>
                          body {
                            font-family: Arial, sans-serif;
                            margin: 0 auto;
                            padding: 5em 0;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            gap: 2.0em;
                          }
                          .page {
                            aspect-ratio: 210 / 296;
                            display: block;
                            width: 210mm;
                            height: 296mm;
                            background-color: #fff;
                            overflow: hidden;
                            word-wrap: break-word;
                            border: 1px #D3D3D3 solid;
                            border-radius: 5px;
                            box-shadow: 0 0 10px rgba(0,0,0,0.3);
                          }
                        </style>
                      </head>
                      <body>
                        ${renderedHtml}
                      </body>
                    </html>
                  `);
                  doc.close();
                }
              }}
            />
          </Grid>
        </Grid>

        <FormSubmit label="Salvar" padding={{ top: "2em" }} />
      </form>
    </PageView>
  );
};

export default FichaTecnicaForm;
